import React, { useState } from "react";
import "./styles.scss";
import { GetIconByName } from "../../config/icon";
import { imageUpload } from "./service/image.service";
import { Store } from "react-notifications-component";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

const Index = ({ data, onClick, onChange }) => {
  const [isLoading, setIsLoading] = useState(false);
  const onChangeImage = async (e) => {
    try {
      setIsLoading(true);
      console.log("Image Upload Event:", e);
      e.preventDefault();
      // Get files from either drag-and-drop or file input
      let files = e.dataTransfer ? e.dataTransfer.files : e.target.files;

      // Check if files exist and have length
      if (!files || files.length === 0) {
        console.warn("No files selected.");
        return;
      }

      // Get the first file from the FileList
      const selectedFile = files[0];

      const MAX_FILE_SIZE = data.fileSize * 1024 * 1024;
      const MAX_WIDTH = data.width + 200;
      const MAX_HEIGHT = data.height + 200;

      if (data.fileSize && selectedFile?.size > MAX_FILE_SIZE) {
        alert("File size exceeds the 2MB limit.");
        return;
      }

      const reader = new FileReader();

      reader.onload = async () => {
        console.log("base64", reader.result);
        const img = new Image();
        img.onload = async () => {
          console.log("Image width:", img.width, "height:", img.height);

          // if (
          //   data.width &&
          //   data.height &&
          //   (img.width > MAX_WIDTH || img.height > MAX_HEIGHT)
          // ) {
          //   alert(
          //     `Image resolution exceeds ${MAX_WIDTH - 200}x${
          //       MAX_HEIGHT - 200
          //     }px`
          //   );
          //   return;
          // }
          const response = await imageUpload({
            name: selectedFile.name,
            filename: selectedFile.name,
            type: selectedFile.type,
            size: selectedFile.size,
            base64_data: reader.result,
            file: selectedFile,
            lastModified: selectedFile.lastModified,
            lastModifiedDate: selectedFile.lastModifiedDate,
          });
          console.log("Image Upload Response:", response);
          if (response?.data) {
            onChange(response.data);
            Store.addNotification({
              title: "Success",
              message: "Image Upload successfully",
              type: "success",
              container: "top-right",
              dismiss: {
                duration: 2000,
                onScreen: true,
              },
            });
          } else {
            Store.addNotification({
              title: "Error",
              message: "Image Upload failed",
              type: "danger",
              container: "top-right",
              dismiss: {
                duration: 2000,
                onScreen: true,
              },
            });
          }
          setIsLoading(false);
        };

        img.onerror = () => {
          alert("Invalid image file.");
        };

        img.src = reader.result;
      };
      reader.readAsDataURL(files[0]);
    } catch (error) {
      setIsLoading(false);
      console.error("Error uploading image:", error);
    }
  };
  let inputElement = null;

  inputElement = (
    <>
      <div
        className={
          "uploader-main-wrapper d-flex flex-column justify-content-start align-items-start"
        }
      >
        {data.isLable && (
          <div className={"uploader-lable"}>{data.uploaderLable}</div>
        )}
        <label
          //  key={data.key}
          className={`upload-wrapper d-flex flex-column justify-content-center align-items-center
           ${data.disabled ? "disabled" : "enabled"}`}
          onClick={!data.disabled && data.onClick}
          for={data.key}
        >
          <input
            // key={data.key}
            // id={data.key}
            type={"file"}
            onChange={!data.disabled && onChangeImage}
            style={{
              visibility: "hidden",
              cursor: data.disabled ? "auto" : "pointer",
            }}
          />
          {data.iconName && !isLoading && (
            <div className={"uw__icon"}>{GetIconByName(data.iconName)}</div>
          )}
          {isLoading && (
            <div className="loader">
              <Spin
                style={{ color: "#c40b4a" }}
                indicator={<LoadingOutlined spin />}
                size="small"
              />
            </div>
          )}
        </label>
      </div>
    </>
  );

  return <>{inputElement}</>;
};
Index.propTypes = {};

Index.defaultProps = {};
export default Index;
